module.exports = __webpack_public_path__ + "aac07fc6db99e7eb977e36c5b2571716.woff2";